module.exports = __webpack_public_path__ + "0785912d4a7b18933fc148449e121679.png";


//////////////////
// WEBPACK FOOTER
// ./app/images/payment-methods-final.png
// module id = ./app/images/payment-methods-final.png
// module chunks = 40